import {selector} from './selector';
import * as events from "./events";
import {verififyRegistrationPlate} from "./events";

const PageRegisterTag = (function ($) {

    function checkTerms() {
        $(selector.btn.submit).prop('disabled', !$(selector.checkTerms).is(':checked'));
    }

    function initEvents() {
        $(document).on('keyup', selector.registrationPlate, events.verififyRegistrationPlate);
        $(document).on('change', selector.form.customerType, events.toggleCustomerType);
    }

    function initialize() {
        initEvents();
        setInterval(checkTerms, 500);

        $(document).on('submit', selector.form.main, function (e) {
            const $submitBtn = $(selector.btn.submit);
            $submitBtn.prop('disabled', true);
            $submitBtn.addClass('disabled');
        });
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageRegisterTag};